export const loggerAction = {
  onload: 'about-page',
  link: 'about-page-link',
  button: 'about-page-button',
  lss: 'about-page-lss-button'
}

export const EMCASA_ABOUT_VIDEO =
  'https://www.youtube.com/embed/1G_nrJ1JO0g?rel=0'
